export enum ProgressMessageType {
    Percentage = 0,
    Text = 1,
    Error = 2,
}
